export default "__VITE_ASSET__af65be78__"